












































































































import { Component } from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';
import CompassIndustry from '@/components/CompassIndustry.vue';
import CompassCompetitors from '@/components/CompassCompetitors.vue';
import SustainabilityCompass from '@/charts/SustainabilityCompass.vue';

@Component({ components: {SustainabilityCompass, CompassCompetitors, CompassIndustry } })
export default class CompassSlide extends Slide {
  hovered: any | null = null;

  onHoverChanged(e: any) {
    this.hovered = e;
  }
}
